import { AgentsSection } from './components/AgentsSection'
import { EcosystemSection } from './components/EcosystemSection'
import { FooterSection } from './components/FooterSection'
import { GetStartedSection } from './components/GetStartedSection'
import { Hero } from './components/Hero'
import { MetricsSection } from './components/MetricsSection'
import { NavBar } from './components/NavBar'
import { StackSection } from './components/StackSection'

/**
 * Section order: what it is → the five domains → the agents that act on them →
 * what it measures → where it sits in the ecosystem → how to start.
 *
 * Get Started sits last deliberately. The reference site puts its install
 * section third because its funnel is a download; Thinai's is "connect a
 * repository", which only makes sense once the value is established.
 */
export function App() {
  return (
    <>
      <NavBar />
      <main id="top">
        <Hero />
        <StackSection />
        <AgentsSection />
        <MetricsSection />
        <EcosystemSection />
        <GetStartedSection />
      </main>
      <FooterSection />
    </>
  )
}
